import { z } from "zod";

const configSchema = z.object({
  apiBaseUrl: z.string().url(),
  supabaseUrl: z.string().url(),
  supabasePublishableKey: z.string().min(20),
});

export type RuntimeConfig = z.infer<typeof configSchema>;

let runtimeConfig: RuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const fallback = {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
    supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  };
  let input: unknown = fallback;
  try {
    const response = await fetch("/admin-config.json", { cache: "no-store" });
    if (response.ok) input = await response.json();
  } catch {
    input = fallback;
  }
  runtimeConfig = configSchema.parse(input);
  return runtimeConfig;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!runtimeConfig)
    throw new Error("Runtime configuration has not been loaded.");
  return runtimeConfig;
}
